var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"map-canvas-2",attrs:{"id":"map"}})])
}]

export { render, staticRenderFns }